export default __webpack_public_path__ + "static/media/eye_black.97708e8f.svg";